import React from 'react';

const About: React.FC = () => {
  return (
    <div className="container">
      <h3>About</h3>
      
      <p>
        This Zakat Calculator is provided by Islam Answers to help Muslims calculate their Zakat obligations accurately.
      </p>
      
      <h4>About Islam Answers</h4>
      <p>
        Islam Answers is dedicated to providing authentic Islamic knowledge and services to the Muslim community.
      </p>
      
      <h4>Zakat Fund</h4>
      <p>
        Islam Answers provides a service for collecting and distributing zakat on a 100% donation policy, 
        ensuring all of the money goes to Muslim individuals eligible to receive zakat.
      </p>
      
      <p>
        <a className="btn btn-success" href="https://www.islamanswers.co.uk/zakat-fund" role="button">
          Pay Zakat »
        </a>
      </p>
      
      <h4>Contact</h4>
      <p>
        For more information, visit <a href="https://www.islamanswers.co.uk">www.islamanswers.co.uk</a>
      </p>
    </div>
  );
};

export default About;
